import React from "react";

function LoadingSpinner({ height = "50vh", spinnerSize = "20px" }) {
  return (
    <div
      className="d-flex justify-content-center align-items-center w-100"
      style={{ height: height }}
    >
      <div
        className="spinner-border"
        style={{ height: spinnerSize, width: spinnerSize }}
        role="status"
      >
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
}

export default LoadingSpinner;
